const ReportPage = ({}) => {
  return (
    <h2>Страница Отчёты</h2>
  );
};

export default ReportPage;